import { getApiConfig } from "@/config/api.config";
import { BaseApiService } from "@/services/api/BaseApiService";
import { ApiResponse } from "@/services/api/types";

export interface BoughtSkuSummaryParams {
  storeIds: number[];
  sku?: string;
  startDate?: string;
  endDate?: string;
}

export interface BoughtSkuSummary {
  sku: string;
  totalPrice: number;
  numberOfItemsSold: number;
}

interface RequestReportingUser {
  id: number;
  firstName: string;
  lastName: string | null;
}

interface RequestReport {
  id: number;
  status: string;
  createdBy?: number;
  storeId: number;
  changingRoomId?: number;
  assignedUserId?: number;
  sku?: string;
  createdAt: number;
  assignedAt?: number;
  completedAt?: number;
  size?: string;
  color?: string;
  price?: number;
  timeTaken: number;
  type: string;
  itemId?: string;
  productId?: string;
  originalRequestId?: number;
  title?: string;
  category?: string;
  origin?: string;
}

export interface RequestReportItem {
  request: RequestReport;
  user?: RequestReportingUser;
  users?: RequestReportingUser[];
}

export interface RequestReportResponse {
  data: RequestReportItem[];
  metadata?: {
    code: number;
    message: string;
  };
}

export class AnalyticsService extends BaseApiService {
  private static instance: AnalyticsService;

  private constructor() {
    super();
  }

  public static getInstance(): AnalyticsService {
    if (!AnalyticsService.instance) {
      AnalyticsService.instance = new AnalyticsService();
    }
    return AnalyticsService.instance;
  }

  private getAnalyticsBaseUrl(): string {
    return getApiConfig().analytics;
  }

  public async getSkuSalesSummary(
    params: BoughtSkuSummaryParams,
  ): Promise<ApiResponse<BoughtSkuSummary>> {
    try {
      const queryParams = new URLSearchParams();

      for (const id of params.storeIds) {
        queryParams.append("storeId", id.toString());
      }

      if (params.sku) {
        queryParams.append("sku", params.sku);
      }

      if (params.startDate) {
        queryParams.append("startDate", params.startDate);
      }

      if (params.endDate) {
        queryParams.append("endDate", params.endDate);
      }

      return await this.get<ApiResponse<BoughtSkuSummary>>(
        `/analytic/bought-sku-summary?${queryParams.toString()}`,
        this.getAnalyticsBaseUrl(),
      );
    } catch (error) {
      throw error;
    }
  }

  // Add more analytics-related methods here
}
